<template>
  <MaterialFormReact
    :open="isOpen"
    :mode="mode"
    :defaultValues="resource"
    :simpleMode="isSimpleMode"
    :onCreated="handleCreated"
    :onUpdated="handleUpdated"
    :onCancel="handleCancel"
    :onClose="handleClose"
  />
</template>

<script>
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { MaterialFormController } from "@/modules/material/components/MaterialFormController";

const MaterialFormReact = ReactInVue(MaterialFormController);

const DEFAULT_RESOURCE = {
  id: "",
  identifier: "",
  brand: "",
  model: "",
  description: "",
  newStock: 0,
  usedStock: 0,
  storeBox: "",
  price: 0,
  stockMin: 3,
  materialGroup: "",
};

export default {
  name: "MaterialForm",
  components: {
    MaterialFormReact,
  },
  data() {
    return {
      isOpen: false,
      isSimpleMode: false,
      mode: "create",
      resource: { ...DEFAULT_RESOURCE },
    };
  },
  methods: {
    show(val = true) {
      this.isOpen = val;
      if (!val) {
        this.reset();
      }
    },
    enableSimpleMode() {
      this.isSimpleMode = true;
    },
    setResource(resource = {}) {
      this.resource = { ...DEFAULT_RESOURCE, ...resource };
      this.mode = resource && resource.id ? "edit" : "create";
    },
    reset() {
      this.mode = "create";
      this.resource = { ...DEFAULT_RESOURCE };
      this.isSimpleMode = false;
    },
    handleCreated(material) {
      this.$emit("created", material);
    },
    handleUpdated(material) {
      this.$emit("updated", material);
    },
    handleCancel() {
      this.$emit("canceled");
    },
    handleClose() {
      this.isOpen = false;
      this.reset();
    },
  },
};
</script>
